(function($){
	
	jQuery(".carousel-menu li>a").hover(function(e){
		var container=jQuery(e.target).parentsUntil('.carousel-container');
		var backdrop = jQuery(container[container.length-1]).find('.carousel-backdrop');
		if (backdrop.hasClass('active')){
			backdrop.removeClass('active');
		}else{
			backdrop.addClass('active');
		}
	});

	$('.multi-item-carousel .carousel-item').each(function(){
		  var next = $(this).next();
		  if (!next.length) next = $(this).siblings(':first');
		  next.children(':first-child').clone().appendTo($(this));
		});
	
	$('.multi-item-carousel .carousel-item').each(function(){
	  var prev = $(this).prev();
	  if (!prev.length) prev = $(this).siblings(':last');
	  prev.children(':nth-last-child(2)').clone().prependTo($(this));
	});
	
	jQuery(document).ready(function(){
		$('#home-phototheque-carousel').slick( {
			  centerMode: true,
			  centerPadding: '0px',
			  slidesToShow: 3,
			  responsive: [
			    {
			      breakpoint: 768,
			      settings: {
			        arrows: false,
			        centerMode: true,
			        centerPadding: '40px',
			        slidesToShow: 3
			      }
			    },
			    {
			      breakpoint: 480,
			      settings: {
			        arrows: false,
			        centerMode: true,
			        centerPadding: '40px',
			        slidesToShow: 1
			      }
			    }
			  ]
			});
	});

})(jQuery);